var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-arrow-corner-down';
                    var viewUrl = 'sprite.svg#view-icon-arrow-corner-down';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-arrow-corner-down#icon-arrow-corner-down';
                            viewUrl = 'sprite.svg?icon-arrow-corner-down#view-icon-arrow-corner-down';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 12 12',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };